export interface IMediumDiffRequestStatus {
    id: string;
    mediumHash: string;
}

export interface IMediaDiffRequestInner {
    siteId: number;
    hash: string;
    requests: Array<IMediumDiffRequestStatus>;
}

export interface IMediaDiffRequest {
    requestDto: IMediaDiffRequestInner;
}

export enum MediumStatus {
    UpToDate = 'UpToDate',
    New = 'New',
    Updated = 'Updated',
    Deleted = 'Delete',
}

export interface IMediumDiffResponseStatus {
    id: string;
    fileHash: string;
    fileName: string;
    mimeType: string;
    mediumStatus: MediumStatus;
}

export interface IMediaDiffResponse {
    value: Array<IMediumDiffResponseStatus>;
}

export interface IMediaDiffAPI {
    getMediaDiff: (
        authToken: string,
        siteId: number,
        siteHash?: string,
        existingMedia?: Array<IMediumDiffRequestStatus>,
    ) => Promise<IMediaDiffResponse>;
}
